import styled from 'styled-components';

export default styled.div`
  display: block;
  @media (max-width: 480px) {
    display: none;
  }
`;
